import { render, staticRenderFns } from "./StoreCustomizingModal.vue?vue&type=template&id=1b52d5b5"
import script from "./StoreCustomizingModal.vue?vue&type=script&lang=js"
export * from "./StoreCustomizingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports